import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo,useRef } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
import { MultiSelect } from "react-multi-select-component";
import Select, { components } from "react-select";
import { group } from 'd3';

const NMEOOP = () => {
    const navigate = useNavigate();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState('');
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState('');
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState('');
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [surveyValue, setSurveyValue] = useState("");
    const [surveyorNameValue, setSurveyorNameValue] = useState("");
    const [mobilenoValue, setMobilenoValue] = useState("");
    const [landareaValue, setlandareaValue] = useState("");
    const [totalareaValue, settotalareaValue] = useState("");
    const [surveynoValue, setSurveynoValue] = useState("");
    const [editCode, setEditCode] = useState({});
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropSeason, setCropSeason] = useState([]);
    const [cropSeasonValue, setCropSeasonValue] = useState(''); 
    const [cropGroup, setCropGroup] = useState([]);
    const [cropGroupValue, setCropGroupValue] = useState('');
    const [cropName, setCropName] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [cropNameValue, setCropNameValue] = useState('');
    const [isStateDisabled, setIsStateDisabled] = useState(false);
    const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
    const [isSubDistrictDisabled, setIsSubDistrictDisabled] = useState(false);
    const [isRestoring, setIsRestoring] = useState(false);
    const [savedFiltersData, setSavedFiltersData] = useState(null);
    const[selectedCropGroup, setSelectedCropGroup] = useState("");
    const [seasons, setSeasons] = useState([]);
    const [seasonValue, setSeasonValue] = useState(null);
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const [cropGroups, setCropGroups] = useState([]);
    const [selectedSeason, setSelectedSeason] = useState(0);
     const fetchedVillageKeys = useRef(new Set());
    const [cropNames, setCropNames] = useState([]);
    const [selectedCropName, setSelectedCropName] = useState(0);
      const [selectedFinYear, setSelectedFinYear] = useState("All");
      const [finYears, setFinYears] = useState(() => {
        const currentYear = new Date().getFullYear();
        const years = ["All"];

    
      
        // Add last 5 financial years
        for (let i = 0; i < 5; i++) {
          const startYear = currentYear - i;
          const endYear = startYear + 1;
          years.push(`${startYear}-${endYear}`);
        }
    
        return years;
      });
      const getStoredDistrictRef = () => {
        const districtCode = sessionStorage.getItem("districtCodeModel");
        const districtName = sessionStorage.getItem("districtNameModel");
        if (districtCode && districtCode !== "null" && districtCode !== "0") {
            return districtCode;
            
        }
        if (districtName && districtName !== "null" && districtName !== "0") {
            return districtName;
        }
        return "";
    };

    const findMatchingOption = (options, ref) => {
        if (!ref || ref === "null" || ref === "0" || !Array.isArray(options)) return null;
        const refStr = String(ref).trim();
        return options.find((option) =>
            String(option.value) === refStr ||
            option.value == ref ||
            String(option.label).trim().toLowerCase() === refStr.toLowerCase()
        ) || null;
    };

    const findDistrictSelectValue = (options, selectedDistrict) => {
        if (!selectedDistrict || selectedDistrict === "null" || selectedDistrict === "0") return null;
        return findMatchingOption(options, selectedDistrict);
    };

    useEffect(() => {
        // Check for saved data first
        const savedResults = sessionStorage.getItem("searchResults");
        const savedFilters = sessionStorage.getItem("searchFilters");
        
        if (savedResults && savedFilters) {
            console.log("Restoring saved data:", { savedResults: JSON.parse(savedResults), savedFilters: JSON.parse(savedFilters) });
            setIsRestoring(true);
            setSavedFiltersData(JSON.parse(savedFilters));
            setfarmerData(JSON.parse(savedResults));
            setIsFetching(false); // Set loading to false since we have data
            setLoaderFarmer(false); // Stop the loader
        }
        
        // Always fetch states list first
        getStates();
       
    }, []);
    useEffect(() => {
                if (optionDistrict.length > 0) {
                    const userType = sessionStorage.getItem("userTypeCodeModel");
                    const districtCode = getStoredDistrictRef();
                    // First select the district value
                    if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0") {
                        const matchingDistrictOption = findMatchingOption(optionDistrict, districtCode);
                        if (matchingDistrictOption) {
                            setDistrictValue([matchingDistrictOption.value]);
                            setselectedDataSetDistrict(`${matchingDistrictOption.stateid}|${matchingDistrictOption.value}`);
                            
                            // Trigger sub-district loading by calling the API directly
                            const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                            if (stateCode) {
                                fetchSubDistricts(stateCode, matchingDistrictOption.value);
                            }
                        } else {
                            setDistrictValue([districtCode]);
                        }
                    }
                }
            }, [optionDistrict]); // Trigger when district options are loaded
        
      const fetchSubDistricts = async(stateCode, districtCode) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/subdistrict`,
                requestOptions
            );

            const result = await response.text();
            const localFormDataSubDistrict = JSON.parse(result).dataContent;

            let myArraySubDistrict = [];
            localFormDataSubDistrict.map((item, key) => {
                myArraySubDistrict.push({ 
                    label: item.subDistrictName, 
                    value: item.subDistrictCode, 
                    districtCode: item.districtCode 
                });
            });

            setOptionSubDistrict(myArraySubDistrict);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching sub-districts:", error);
        }
    };

    // Function to fetch villages for auto-selected sub-district
    const fetchVillages = async (stateCode, districtCode, subDistrictCode) => {
        // Check if we already tried to fetch villages for this combination
        const villageKey = `${stateCode}-${districtCode}-${subDistrictCode}`;
        if (fetchedVillageKeys.current.has(villageKey)) {
            return; // Don't fetch again
        }
        
        // Mark this combination as attempted
        fetchedVillageKeys.current.add(villageKey);
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString(),
                subDistrictCode: subDistrictCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            );

            const result = await response.text();
            const parsedResult = JSON.parse(result);
            const localFormDataVillage = parsedResult.dataContent;

            let myArrayVillage = [];
            if (localFormDataVillage && localFormDataVillage.length > 0) {
                localFormDataVillage.map((item, key) => {
                    myArrayVillage.push({ 
                        label: item.villageName, 
                        value: item.villageCode, 
                        subDistrictCode: item.subDistrictCode 
                    });
                });
            }

            setOptionVillage(myArrayVillage);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching villages:", error);
            setOptionVillage([]);
            setIsFetching(false);
        }
    };

       useEffect(() => {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const stateCode = sessionStorage.getItem("stateNameModel");
            const districtCode = getStoredDistrictRef();
            const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
           // alert(`User Type: ${userType}, State Code: ${stateCode}, District Code: ${districtCode}, Sub-District Code: ${subDistrictCode}`);
    
            // Set disabled states based on user type and available values
            if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // State admin - freeze state dropdown only
                setIsStateDisabled(true);
                setIsDistrictDisabled(false);
                setIsSubDistrictDisabled(false);
            } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // District admin - freeze state and district dropdowns
                setIsStateDisabled(true);
                if (districtCode) {
                    setIsDistrictDisabled(true);
                }
            } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // Sub-district admin - freeze state dropdown, others will be frozen after they're selected
                setIsStateDisabled(true);
                // For sub-district admin, also set district disabled state if district code is available
                if (districtCode && districtCode !== "null" && districtCode !== "0") {
                    setIsDistrictDisabled(true);
                }
                // District and sub-district will be disabled in their respective useEffects
            } else {
                // Regular user - enable all
                setIsStateDisabled(false);
                setIsDistrictDisabled(false);
                setIsSubDistrictDisabled(false);
            }
        }, [stateValue]); // Trigger when stateValue changes
    
          useEffect(() => {
                if (optionDistrict.length > 0) {
                    const userType = sessionStorage.getItem("userTypeCodeModel");
                    const districtCode = getStoredDistrictRef();
                    // First select the district value
                    if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0") {
                        const matchingDistrictOption = findMatchingOption(optionDistrict, districtCode);
                        if (matchingDistrictOption) {
                            setDistrictValue([matchingDistrictOption.value]);
                            setselectedDataSetDistrict(`${matchingDistrictOption.stateid}|${matchingDistrictOption.value}`);
                            
                            // Trigger sub-district loading by calling the API directly
                            const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                            if (stateCode) {
                                fetchSubDistricts(stateCode, matchingDistrictOption.value);
                            }
                        } else {
                            setDistrictValue([districtCode]);
                        }
                    }
                }
            }, [optionDistrict]); // Trigger when district options are loaded
        
            // Separate useEffect to freeze district dropdown after district value is set
            useEffect(() => {
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const districtCode = getStoredDistrictRef();
                
                // Freeze district dropdown for district and sub-district admins
                if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0" && districtValue.length > 0) {
                    setIsDistrictDisabled(true);
                    
                
                }
            }, [districtValue]); // Trigger when districtValue changes
        
            // New useEffect to handle sub-district auto-selection after sub-districts are loaded
            useEffect(() => {
                if (optionSubDistrict.length > 0) {
                    const userType = sessionStorage.getItem("userTypeCodeModel");
                    const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
                    
                    // First select the sub-district value
                    if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0") {
                        // Try to find matching option with different data types
                        const matchingOption = optionSubDistrict.find(option => 
                            option.value == subDistrictCode || 
                            option.value === Number(subDistrictCode) || 
                            option.value === String(subDistrictCode)
                        );
                        
                        if (matchingOption) {
                            setsubDistrictValue([matchingOption.value]);
                            setselectedDataSetSubDistrict(`${matchingOption.districtCode}|${matchingOption.value}`);
                            
                            // Trigger village loading for sub-district admin
                            const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                            const districtCode = districtValue[0] || getStoredDistrictRef() || matchingOption.districtCode;
                            
                            console.log("Sub-district auto-selection - Village loading attempt:", {
                                stateCode,
                                districtCode,
                                subDistrictCode: matchingOption.value,
                                stateValue,
                                districtValue,
                                matchingOption
                            });
                            
                            if (stateCode && districtCode) {
                                // Add a small delay to ensure all state updates are processed
                                setTimeout(() => {
                                    fetchVillages(stateCode, districtCode, matchingOption.value);
                                }, 100);
                            } else {
                                console.log("Village loading skipped - missing state or district code");
                            }
                        } else {
                            setsubDistrictValue([subDistrictCode]);
                        }
                    }
                }
            }, [optionSubDistrict, stateValue, districtValue]); // Trigger when sub-district options are loaded and state/district values are set
        
    // Effect to handle district selection
    useEffect(() => {
        if (districtValue && stateValue && stateValue.length > 0 && optionDistrict.length > 0) {
            // Only trigger if we have both state and district values and district options are loaded
            const districtOption = findDistrictSelectValue(optionDistrict, districtValue);

            if (districtOption) {
                handleChangeDistrict(districtOption);
            }
        }
    }, [districtValue, optionDistrict]);

    // Effect to restore saved filters after options are loaded
    useEffect(() => {
        if (isRestoring && savedFiltersData && optionState.length > 0) {
            console.log("Restoring saved filters:", savedFiltersData);
            
            // Restore state
            if (savedFiltersData.stateValue && savedFiltersData.stateValue.length > 0) {
                setStateValue(savedFiltersData.stateValue);
                // Load districts for the saved state but don't trigger isFetching reset
                handleStateForRestore(savedFiltersData.stateValue[0]);
            }
            
            // Set other saved values
            if (savedFiltersData.districtValue) {
                setDistrictValue(savedFiltersData.districtValue);
            }
            if (savedFiltersData.subDistrictValue) {
                setsubDistrictValue(savedFiltersData.subDistrictValue);
            }
            if (savedFiltersData.villageValue) {
                setvillageValue(savedFiltersData.villageValue);
            }
            if (savedFiltersData.selectedDataSetDistrict) {
                setselectedDataSetDistrict(savedFiltersData.selectedDataSetDistrict);
            }
            if (savedFiltersData.selectedDataSetSubDistrict) {
                setselectedDataSetSubDistrict(savedFiltersData.selectedDataSetSubDistrict);
            }
            if (savedFiltersData.selectedDataSetVillage) {
                setselectedDataSetVillage(savedFiltersData.selectedDataSetVillage);
            }
            
            setIsRestoring(false);
        }
    }, [isRestoring, savedFiltersData, optionState]);

    // Effect to restore district after districts are loaded
    useEffect(() => {
        if (savedFiltersData && optionDistrict.length > 0 && savedFiltersData.districtValue) {
            const districtOption = findDistrictSelectValue(optionDistrict, savedFiltersData.districtValue);
            if (districtOption && savedFiltersData.subDistrictValue) {
                // Load sub-districts for the saved district using restore function
                loadSubDistrictsForRestore(savedFiltersData.stateValue[0], savedFiltersData.districtValue);
            }
        }
    }, [optionDistrict, savedFiltersData]);

    // Effect to restore sub-district after sub-districts are loaded
    useEffect(() => {
        if (savedFiltersData && optionSubDistrict.length > 0 && savedFiltersData.subDistrictValue) {
            const subDistrictOption = optionSubDistrict.find(option => option.value === savedFiltersData.subDistrictValue);
            if (subDistrictOption && savedFiltersData.villageValue) {
                // Load villages for the saved sub-district using restore function
                loadVillagesForRestore(savedFiltersData.stateValue[0], savedFiltersData.districtValue, savedFiltersData.subDistrictValue);
            }
        }
    }, [optionSubDistrict, savedFiltersData]);
    

    useEffect(() => {

        if (isFetchingState == false) {

            handleState();
            setIsFetchingState(true);
        }

    }, [stateValue]);

    function getStates() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/states`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                let myArray = [];
                localFormDataState.map((item) => {
                    myArray.push({
                        value: item.stateCode,
                        label: item.stateName,
                    });
                });
                setOptionState(myArray);

                // After states are loaded, handle user type specific logic
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const stateCode = sessionStorage.getItem("stateNameModel");
                const districtCode = sessionStorage.getItem("districtNameModel");
               // alert(`District Code: ${districtCode}, User Type: ${userType}, State Code: ${stateCode}`);
                
                
                if ((userType === "2" || userType === "3"|| userType === "4") && stateCode && stateCode !== "null") {
                    // Find the matching state in our options
                    const matchingState = myArray.find(state => 
                        String(state.value) === String(stateCode)
                    );
                    
                    if (matchingState) {
                        console.log("Auto-selecting state:", matchingState);
                        setStateValue([matchingState.value]);
                        setIsStateDisabled(true);
                        
                        // Load districts for the selected state
                        handleState(matchingState.value);
                    } else {
                        console.error("Could not find matching state for code:", stateCode);
                    }
                }
            })
            .catch((error) => console.error("Error fetching states:", error));
    }

    // Special handleState function for restoration that doesn't clear farmer data
    function handleStateForRestore(stateCodeParam) {
        console.log("handleStateForRestore called with stateCode:", stateCodeParam);
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
            stateCode: stateCodeParam.toString()
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/district`,
            requestOptions
        )
        .then((response) => response.text())
        .then((result) => {
            let localFormDataDistrict = JSON.parse(result).dataContent;
            console.log("Districts loaded for restore:", localFormDataDistrict);

            let myArrayDistrict = [];
            localFormDataDistrict.map((item, key) => {
                myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
            });

            setOptionDistrict(myArrayDistrict);

            const userType = sessionStorage.getItem("userTypeCodeModel");
            const districtRef = getStoredDistrictRef();
            if ((userType === "3" || userType === "4") && districtRef) {
                const districtOption = findMatchingOption(myArrayDistrict, districtRef);
                if (districtOption) {
                    setDistrictValue(districtOption.value);
                    
                    setIsDistrictDisabled(true);
                    setselectedDataSetDistrict(`${districtOption.stateid}|${districtOption.value}`);
                    
                    loadSubDistricts(stateCodeParam, districtOption.value);
                }
            }
        })
        .catch((error) => console.log("error during restore", error));
    }

    function handleState(stateCodeParam = null) {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        console.log("handleState called with stateValue:", currentStateValue, "param:", stateCodeParam);
        
        // If state is cleared (empty array), reset everything and return
        if (!currentStateValue || currentStateValue.length === 0) {
            console.log("State cleared - resetting districts and setting isFetching to false");
            setOptionDistrict([]);
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
            setOptionVillage([]);
            setvillageValue('');
            setselectedDataSetVillage('');
            setIsFetching(false);
            return;
        }
        
        if (currentStateValue && currentStateValue.length > 0) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = currentStateValue[0];
            console.log("Fetching districts for state:", stateValueData);
            
            var raw = JSON.stringify({
                stateCode: stateValueData.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/district`,
                requestOptions
            )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataDistrict = JSON.parse(result).dataContent;
                console.log("Districts loaded:", localFormDataDistrict);

                let myArrayDistrict = [];
                localFormDataDistrict.map((item, key) => {
                    myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                });

                setOptionDistrict(myArrayDistrict);
                
                // Auto-select district for district / sub-district admin
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const districtRef = getStoredDistrictRef();

                if ((userType === "3" || userType === "4") && districtRef) {
                    const districtOption = findMatchingOption(myArrayDistrict, districtRef);

                    if (districtOption) {
                        setDistrictValue(districtOption.value);
                        setIsDistrictDisabled(true);
                        setselectedDataSetDistrict(`${districtOption.stateid}|${districtOption.value}`);
                        loadSubDistricts(stateValueData, districtOption.value);
                    } else {
                        console.error("Could not find matching district for:", districtRef);
                    }
                }
                
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
        }
    }

    // Helper function to load sub-districts
    function loadSubDistricts(stateCode, districtCode) {
        console.log("Loading sub-districts for state:", stateCode, "district:", districtCode);
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
            stateCode: stateCode.toString(),
            districtCode: districtCode.toString()
        });
        
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw
        };
        
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
        .then((response) => response.text())
        .then((result) => {
            let localFormDataSubDistrict = JSON.parse(result).dataContent;
            console.log("Sub-districts loaded:", localFormDataSubDistrict);
            
            let myArraySubDistrict = [];
            localFormDataSubDistrict.map((item, key) => {
                myArraySubDistrict.push({ 
                    label: item.subDistrictName, 
                    value: item.subDistrictCode, 
                    districtCode: item.districtCode 
                });
            });
            
            setOptionSubDistrict(myArraySubDistrict);
            console.log("Sub-district options set:", myArraySubDistrict);
        })
        .catch((error) => console.log("error loading sub-districts:", error));
    }

    // Helper function to load sub-districts for restoration (doesn't affect loading states)
    function loadSubDistrictsForRestore(stateCode, districtCode) {
        console.log("Loading sub-districts for restore - state:", stateCode, "district:", districtCode);
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
            stateCode: stateCode.toString(),
            districtCode: districtCode.toString()
        });
        
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw
        };
        
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
        .then((response) => response.text())
        .then((result) => {
            let localFormDataSubDistrict = JSON.parse(result).dataContent;
            console.log("Sub-districts loaded for restore:", localFormDataSubDistrict);
            
            let myArraySubDistrict = [];
            localFormDataSubDistrict.map((item, key) => {
                myArraySubDistrict.push({ 
                    label: item.subDistrictName, 
                    value: item.subDistrictCode, 
                    districtCode: item.districtCode 
                });
            });
            
            setOptionSubDistrict(myArraySubDistrict);
        })
        .catch((error) => console.log("error loading sub-districts for restore:", error));
    }

    // Helper function to load villages
    function loadVillages(stateCode, districtCode, subDistrictCode) {
        console.log("Loading villages for state:", stateCode, "district:", districtCode, "sub-district:", subDistrictCode);
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
            stateCode: stateCode.toString(),
            districtCode: districtCode.toString(),
            subDistrictCode: subDistrictCode.toString()
        });
        
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw
        };
        
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/village`,
            requestOptions
        )
        .then((response) => response.text())
        .then((result) => {
            let localFormDataVillage = JSON.parse(result).dataContent;
            console.log("Villages loaded:", localFormDataVillage);
            
            let myArrayVillage = [];
            localFormDataVillage.map((item, key) => {
                myArrayVillage.push({ 
                    label: item.villageName, 
                    value: item.villageCode, 
                    subDistrictCode: item.subDistrictCode 
                });
            });
            
            setOptionVillage(myArrayVillage);
            console.log("Village options set:", myArrayVillage);
        })
        .catch((error) => console.log("error loading villages:", error));
    }

    // Helper function to load villages for restoration (doesn't affect loading states)
    function loadVillagesForRestore(stateCode, districtCode, subDistrictCode) {
        console.log("Loading villages for restore - state:", stateCode, "district:", districtCode, "sub-district:", subDistrictCode);
        
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        var raw = JSON.stringify({
            stateCode: stateCode.toString(),
            districtCode: districtCode.toString(),
            subDistrictCode: subDistrictCode.toString()
        });
        
        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw
        };
        
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/village`,
            requestOptions
        )
        .then((response) => response.text())
        .then((result) => {
            let localFormDataVillage = JSON.parse(result).dataContent;
            console.log("Villages loaded for restore:", localFormDataVillage);
            
            let myArrayVillage = [];
            localFormDataVillage.map((item, key) => {
                myArrayVillage.push({ 
                    label: item.villageName, 
                    value: item.villageCode, 
                    subDistrictCode: item.subDistrictCode 
                });
            });
            
            setOptionVillage(myArrayVillage);
        })
        .catch((error) => console.log("error loading villages for restore:", error));
    }

    // Handle state changes
    let handleChange = (selectedOption) => {
        // Check user type - if state admin (type 2) or district admin (type 3), don't allow changes
        const userType = sessionStorage.getItem("userTypeCodeModel");
        if (userType === "2" || userType === "3") {
            console.log("State change blocked - User is admin type:", userType);
            return;
        }
        
        console.log("State changed to:", selectedOption);
        setIsFetchingState(false);
        setStateValue(selectedOption ? [selectedOption.value] : []);
        
        // Clear dependent fields
        if (!selectedOption) {
            setDistrictValue('');
            setOptionDistrict([]);
            setsubDistrictValue('');
            setOptionSubDistrict([]);
            setvillageValue('');
            setOptionVillage([]);
            setselectedDataSetDistrict('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
            // Clear farmer data when state is cleared
            setfarmerData([]);
            setErrorMessage('');
        }
    };

    // Handle district changes
    let handleChangeDistrict = (selectedOption) => {
        // Check user type - if district admin (type 3), don't allow changes
        const userType = sessionStorage.getItem("userTypeCodeModel");
        if (userType === "3") {
            console.log("District change blocked - User is district admin");
            return;
        }
        
        console.log("District changed to:", selectedOption);
        if (selectedOption && selectedOption.value) {
            setDistrictValue(selectedOption.value);
            
            // Safely handle stateid - use stateValue[0] if stateid is not available
            const stateId = selectedOption.stateid || (stateValue && stateValue.length > 0 ? stateValue[0] : '');
            if (stateId) {
                setselectedDataSetDistrict(`${stateId}|${selectedOption.value}`);
                // Load sub-districts
                loadSubDistricts(stateId, selectedOption.value);
            }
        } else {
            // Clear dependent fields
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setOptionVillage([]);
            setvillageValue('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
        }
    };

    let handleChangeSubDistrict = (selectedOption) => {
        setvillageValue('');
        setOptionVillage([]);
        
        if (selectedOption) {
            setsubDistrictValue(selectedOption.value);
            setselectedDataSetSubDistrict(`${selectedOption.districtCode}|${selectedOption.value}`);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            
            var raw = JSON.stringify({
                stateCode: stateValue[0].toString(),
                districtCode: districtValue.toString(),
                subDistrictCode: selectedOption.value.toString()
            });
            
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };
            
            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataVillage = JSON.parse(result).dataContent;
                
                let myArrayVillage = [];
                localFormDataVillage.map((item, key) => {
                    myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                });
                
                setOptionVillage(myArrayVillage);
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
        } else {
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
        }
    };

    let handleChangeVillage = (selectedOption) => {
        if (selectedOption) {
            setvillageValue(selectedOption.value);
            setselectedDataSetVillage(`${selectedOption.subDistrictCode}|${selectedOption.value}`);
        } else {
            setvillageValue('');
            setselectedDataSetVillage('');
        }
    };

    const fetchDataFilterWise = async () => {

        setLoaderFarmer(true);
        setfarmerData([]);
        let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";
         stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
        let result;

        if (sessionStorage.getItem("schemeCodeModel") === "5") {
            setLoaderFarmer(true);
           // result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEOS/getNMEOSFarmerDetailsAll`, {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEOS/FarmerDetailsforDashboard`, {
                "SchemeCode": "5",
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "int_State_Code": stateValueData,
                "int_District_Code": districtValueData,
                "int_SubDistrict_Code": subdistrictValueData,
                 "int_VillageCode": villageValueData,
                 "intSeasonCode" : Number(seasonValue ?? 0),
                 "intCropGroupCode": Number(selectedCropGroup ?? 0),
                 "intCropNameCode": Number(selectedCropName ?? 0),
                 "str_FinYear": selectedFinYear === "All" ? "" : selectedFinYear, 
            })


            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
            sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem(
              "searchFilters",
              JSON.stringify({
                stateValue,
                districtValue,
                subDistrictValue: subdistrictValueData,
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage,
                seasonValue,
                selectedFinYear,
              })
            );
             if (result.data.success != true) {
                  alert('No Data Found.');
                  setLoaderFarmer(false);
            }

        }
    }

    function formatData(value) {
        if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11") {
            return value.componentName
        }
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Honey Processing Unit"
        } else if (value.orgTypeCode === 2) {
            return "Honey Testing Unit"
        } else if (value.orgTypeCode === 3) {
            return "Honey CHC"
        } else if (value.orgTypeCode === 4) {
            return "Beeflora Plantation"
        }
    }

    function formatData2(value) {
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Nursery"
        } else if (value.orgTypeCode === 2) {
            return "Tissue Culture Unit"
        } else {
            return "Tissue Culture Unit"
        }
    }

    const fetchDataExporttoCsv = async () => {
      setLoaderFarmer(true);
      
      let stateValueData = "";
      let districtValueData = "0";
      let subdistrictValueData = "0";
      let villageValueData = "0";

      // Concatenate all state values with a comma
      stateValue.forEach((item) => {
        stateValueData += item + ",";
      });
      // Remove trailing comma
      stateValueData = stateValueData.slice(0, -1);

      // If stateValueData is null or empty, set stateCode to "0"
      const stateCode = stateValueData === "" || stateValueData === null ? "0" : stateValueData;

      if (selectedDataSetDistrict !== "") {
        const districtParts = selectedDataSetDistrict.split("|");
        districtValueData = districtParts[1];
      }
      if (selectedDataSetSubDistrict !== "") {
        const SubdistrictParts = selectedDataSetSubDistrict.split("|");
        subdistrictValueData = SubdistrictParts[1];
      }
      if (selectedDataSetVillage !== "") {
        const VillageDataParts = selectedDataSetVillage.split("|");
        villageValueData = VillageDataParts[1];
      }
      console.log("stateValueData", stateCode);
      console.log("districtValueData", districtValueData);
      console.log("subdistrictValueData", subdistrictValueData);
      console.log("villageValueData", villageValueData);

      let result;
      if (sessionStorage.getItem("schemeCodeModel") === "12") {
        result = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsExport`,
          {
            
            stateCode: stateCode, // Use our conditional stateCode here
            districtCode: districtValueData,
            subDistrictCode: subdistrictValueData,
            villageCode: villageValueData,
            PageNumber: 1,
          }
        );
        if (result.data.success === true) {
          const data = await result.data.dataContent;
          setIsFetching(false);
          setLoaderFarmer(false);
          return data;
        } else {
          alert("something went wrong.");
          setLoaderFarmer(false);
        }
      }
    };


    const handleExportDataNew = async () => {
        //alert(sessionStorage.getItem("schemeCodeModel") );
        let allowed;
        const farmerDataExportNew = await fetchDataExporttoCsv();
        allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        //console.log("Test Data", farmerDataExportNew[0]);
        var result = farmerDataExportNew.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });
            return newObj;
        });
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);

    }
    const handleExportDataNewu = async () => {
    try {
        // Fetch data
        const farmerDataExportNew = await fetchDataExporttoCsv();
       //  console.log("aaaaaaaaaaaaaaaaaaaaaaa",farmerDataExportNew.data.dataContent)
        if(farmerDataExportNew.data.dataContent.length !=0){
        // Check if data is valid
        if (!farmerDataExportNew || !Array.isArray(farmerDataExportNew)) {
            console.error("Error: fetchDataExporttoCsv() returned invalid data", farmerDataExportNew);
            alert("Failed to export: No data available.");
            return;
        }

        // Allowed keys for export
       // const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName']
       

        // Transform data
        const result = farmerDataExportNew.map(obj => {
            let newObj = {};
            allowed.forEach(key => {
                newObj[key] = obj[key] ?? ""; // Ensure empty string for missing values
            });
            return newObj;
        });

        console.log("Export Data:", result);
        // Add export logic here
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
       } 
    } catch (error) {
        console.error("Error in handleExportDataNew:", error);
        alert("An error occurred while exporting data.");
    }
    };


//     const handleExportData = () => {
//         // alert(sessionStorage.getItem("schemeCodeModel") );
//         let allowed;

//         allowed = [ 'stateName', 'districtName', 'subDistrictName', 'villageName','farmerName','casteCatName','taCultivationUnderMission','taUnderOilSeedCultivation','seedQuantityKg','mobileNo','cropGroupName','cropName','seasonName','custumMessage','finYear','surveyorUserCode'];

//         var result = farmerData?.map(function (obj) {
//             var newObj = {};

//             allowed.forEach(function (key) {

//                 newObj[key] = obj[key];


//             });


//             return newObj;
//         });
        

//     const stateName = farmerData?.[0]?.stateName?.replace(/\s+/g, '_') || 'UnknownState';
//     const filename = `NMEOS_${stateName}`;


//         const csvOptions = {
//             fieldSeparator: ",",
//             quoteStrings: '"',
//             decimalSeparator: ".",
//             showLabels: true,
//             useBom: true,
//             useKeysAsHeaders: false,
//             headers: allowed,
//             filename: filename 
//         };
//         const headers = [
//     'State Name',
//     'District Name',
//     'Sub District Name',
//     'Village Name',
//     'Farmer Name',
//     'Caste Category',
//     'TA Cultivation Under Mission',
//     'TA Under Oilseed Cultivation',
//     'Seed Quantity (Kg)',
//     'Mobile Number',
//     'Crop Group Name',
//     'Crop Name',
//     'Season Name',
//     'Cereated On',
//     'Financial Year',
//     'Surveyor User Code'
// ];


//         const csvExporter = new ExportToCsv(csvOptions);
//         csvExporter.generateCsv(result);
//     };

const handleExportData = () => {

    const allowed = [
        'stateName', 'districtName', 'subDistrictName', 'villageName',
        'farmerName', 'casteCatName', 'taCultivationUnderMission',
        'taUnderOilSeedCultivation', 'seedQuantityKg', 'mobileNo',
        'cropGroupName', 'cropName', 'seasonName', 'custumMessage',
        'finYear', 'surveyorUserCode'
    ];

    const headers = [
        'State Name',
        'District Name',
        'Sub District Name',
        'Village Name',
        'Farmer Name',
        'Caste Category',
        'TA Cultivation Under Mission',
        'TA Under Oilseed Cultivation',
        'Seed Quantity (Kg)',
        'Mobile Number',
        'Crop Group Name',
        'Crop Name',
        'Season Name',
        'Created On',
        'Financial Year',
        'Surveyor User Code'
    ];

    var result = farmerData?.map(function (obj) {
        var newObj = {};

        allowed.forEach(function (key) {
            newObj[key] = obj[key];
        });

        return newObj;
    });

    const stateName = farmerData?.[0]?.stateName?.replace(/\s+/g, '_') || 'UnknownState';
    const filename = `NMEOS_${stateName}`;

    const csvOptions = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers: headers,   // ✅ FIXED HERE
        filename: filename
    };

    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(result);
};


    function ValidateUpdateUser() {

        let valid = false;

        if (mobilenoValue === "") {
            alert("Enter Mobile no")

            valid = false;
            return;
        } else {
            valid = true;

        }
        if (landareaValue === "") {
            alert("Enter land area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (totalareaValue === "") {
            alert("Enter total area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (surveynoValue === "") {
            alert("Enter Survey No")

            valid = false;
            return;
        } else {
            valid = true;

        }


        if (valid === true) {
            UpdateNewUser()
        }



    }

    function UpdateNewUser() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
            "farmerCode": editCode,
            "mobileNo": mobilenoValue,
            "surveyNo": surveynoValue,
            "landArea": landareaValue,
            "totalArea": totalareaValue
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Nature/FarmerDetails/UpdateFarmerDetails`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
               // alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    // navigate("/newadminpanel/userlist");
                }
            })
            .catch((error) => console.log("error", error));

    }

    const handlePrevPage = async () => {
        setLoaderFarmer(true);
        let result;
        setPage(page - 1);
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1
            })
        }
       else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page - 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        setIsFetching(false);
        setHasNextPage(true)
    };

    const handleNextPage = async () => {
        setLoaderFarmer(true);

        setPage(page + 1);
        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page + 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        if (result.data.message === "Data Not Found") {
            setHasNextPage(false)
        }
        setIsFetching(false);
    };


    function handleSurveyNumber(value) {
        const valueFinal = value.replace(/\D/g, "");
        setSurveyValue(valueFinal)
    }

    function handleSurveyorName(value) {
        //alert(value);
       // const valueFinal = value.replace(/\D/g, "");
        setSurveyorNameValue(value)
        console.log("value==========",value)
        
    }



    const fetchDataFilterWises = async () => {
        setLoaderFarmer(true);
        setfarmerData([]);
        let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";
        


        stateValue.map((item) => {
            stateValueData = stateValueData + item + ","
        })

        stateValueData = stateValueData.slice(0, -1);

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
      

        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "12") {

            if (surveyValue != '') {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetails`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "CropSurveyCode": surveyValue
                });
            }
            else {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "schemeCode": "12",
                    "stateCode": stateValueData,
                    "districtCode": districtValueData,
                    "subDistrictCode": subdistrictValueData,
                    "villageCode": villageValueData,
                    "surveyorName": surveyorNameValue,
                    "cropSeasonValue": cropSeasonValue,
                    "cropGroupValue": cropGroupValue,
                    "cropNameValue": cropNameValue,
                    "fromdate": startDate,
                    "todate": endDate,
                    "PageNumber": 1
                });
            }


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
                subDistrictValue: subdistrictValueData,
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage,
                mobilenoValue,
                cropNameValue
            }));
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "14") {
alert("123");
          
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEO_OP/getNMEOFarmerDetailsList`, {
                   
                    "schemeCode": "14",
                    "orgTypeCode": "1",
                    "lngA_FarmerCode": "0",
                    "int_Block_Code": "0",
                    "lng_SurveyUserCode": "0",
                    "str_MobileNo": "",
                    "int_State_Code": stateValueData,
                    "int_District_Code": districtValueData,
                    "int_SubDistrict_Code": subdistrictValueData,
                    "int_VillageCode": villageValueData,
         });
            

console.log("result", result.data);
            if (result.data.success === true) {
alert("Data Found Successfully");
                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
                sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
                subDistrictValue: subdistrictValueData,
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "9") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           } 

        if (sessionStorage.getItem("schemeCodeModel") === "15") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/RKVY/RKVYProject/RKVYProjectExtList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": districtValueData,
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           }         

    };

    function ClearSearch(){
        setStateValue([]);
        setOptionDistrict([]);
        setDistrictValue('');
        setfarmerData([]);
        setselectedDataSetDistrict('');
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');
        setselectedDataSetSubDistrict('');
        setselectedDataSetVillage('');
        setSurveyValue('');
        setSurveyorNameValue('');
        setStartDate("");
        setEndDate("");
        setIsRestoring(false);
        setSavedFiltersData(null);
        setSeasonValue(null);
        setSelectedFinYear("All");
        sessionStorage.removeItem("searchResults");
        sessionStorage.removeItem("searchFilters");
    }
     

   const SchemeCode  = sessionStorage.getItem("schemeCodeModel");
    function ValidateAddUser() {
    //alert(sessionStorage.getItem("schemeCodeModel"))
   // alert()
   
    if (stateValue.length === 0) {
       
         setErrorMessage("Please select at least one State.");
            return false;
    }
    if (stateValue.length > 1) {
       setErrorMessage("Please select only one State.");
            return false;
    }
   
    // District validation - ensure it's not an array for single select
    if (Array.isArray(districtValue) && districtValue.length > 1) {
        setErrorMessage('Please select only one District');
        return false;
    }
    
    if (sessionStorage.getItem("schemeCodeModel") === "12") {
    if (!startDate) {
         setErrorMessage('Start Date is required.');
       
        return false;
    }

     if (!endDate) {
        setErrorMessage('End Date is required.');
        return false;
    } else if (startDate && endDate < startDate) {
        setErrorMessage('End Date cannot be earlier than Start Date.');
        return false;
        
    }

    }
    // If all validations pass, fetch the filtered data
    setErrorMessage("") 
    fetchDataFilterWise();

    }


    function navigateData(userData) {
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }
   
  const seasonOptions  =   [{value: 0, label: "All"} ,
                             ...seasons.map(season => ({
                                value: season.seasonCode,
                                label: season.seasonName
                            }))] ;
const cropGroupOptions  =   [{value: 0, label: "All"} ,
                             ...seasons.map(group => ({
                                value: group.groupCode,
                                label: group.groupName
                            }))] ;                            


 const selectedSeasonOption =
   seasonValue != null
     ? seasonOptions.find((o) => o.value === seasonValue) || null
     : null;                           


    const columns = useMemo(() => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

        return [
            {
                header: 'S.No',
                size: 40,
                Cell: cell => Number(cell.row.id) + 1

            },
               // View Details Button Logic
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessor: '',
                header: 'View Details',
                size: 100,
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/survey/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            } : (schemeCodeModel === "9") ? {
                accessor: '',
                header: 'Action',
                size: 100,
                Cell: cell => (<>
                    <i className="btn" type="button" onClick={() => navigateData(cell.row.original)}> <FontAwesomeIcon icon={faEye} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setEditCode(cell.row.original.farmerCode)}> <FontAwesomeIcon icon={faEdit} /></i>
                </>)
            } : {
                accessor: '',
                header: 'View Details',
                size: 100,
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            },
            {
                accessorKey: 'farmerName',
                size: 100,
                header: 'Farmer Name',
            },{
                accessorKey: 'stateName',
                size: 100,
                header: 'State',
            },
            {
                accessorKey: 'districtName',
                size: 100,
                header: 'District',
            },
            
            {
                accessorKey: 'mobileNo',
                size: 100,
                header: 'Mobile No',
            },

                 ...(schemeCodeModel === "5" ? [
        { accessorKey: 'seasonName', header: 'Season Name' },
        { accessorKey: 'custumMessage', header: 'Create On' },
        { accessorKey: 'finYear', header: 'Financial Year'}
    ] 
    : []),
            
           
                 ...(schemeCodeModel === "15" ? [
        { accessorKey: 'userName', header: 'User Name' },
        { accessorKey: 'sectorName', header: 'Sector Name' },
        { accessorKey: 'projectStatus', header: 'Project Status' }
    ] 
    : []),

         
       
        ].filter(Boolean); // Use .filter(Boolean) to remove null entries
    }, []);


        useEffect(() => {
          
        const fetchSeasons = async () => {
          try {
            const baseUrl =
              process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;
            const res = await axios.get(`${baseUrl}/api/seasons`);
    
            console.log("Hii This is the Seasons " ,res?.data?.dataContent);
            setSeasons(res?.data?.dataContent || []);
          } catch (err) {
            console.error("Error fetching seasons:", err);
          }
        };
     fetchSeasons();
      }, []);
 useEffect(() => {
    const fetchCropGroups = async () => {
      try {
        const baseUrl =
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;
        const toSafeInt = (value) => {
          const raw = String(value ?? "").trim().toLowerCase();
          if (!raw || raw === "null" || raw === "undefined") return 0;
          if (!/^\d+$/.test(raw)) return 0;
          const parsed = Number(raw);
          return Number.isNaN(parsed) ? 0 : parsed;
        };

        const safeStateCode = toSafeInt(sessionStorage.getItem("stateCodeModel"));
        const safeDistrictCode = toSafeInt(
          sessionStorage.getItem("districtCodeModel")
        );
        const safeSubDistrictCode = toSafeInt(
          sessionStorage.getItem("subDistrictCodeModel")
        );
        const safeVillageCode = toSafeInt(
          sessionStorage.getItem("villageCodeModel")
        );

        // Keep storage clean so future payloads don't send "null"/"null1".
        sessionStorage.setItem("stateCodeModel", String(safeStateCode));
        sessionStorage.setItem("districtCodeModel", String(safeDistrictCode));
        sessionStorage.setItem("subDistrictCodeModel", String(safeSubDistrictCode));
        sessionStorage.setItem("villageCodeModel", String(safeVillageCode));

        const payload = {
         // SchemeCode: "5"
         schemeCode: schemeCode,
        };

        const res = await axios.post(
          `${baseUrl}/api/Management/CommCropGroup/getCropGroupExtList`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const list = res?.data?.dataContent || [];
        // Build unique crop groups in O(n) for large "All" responses.
        const uniqueGroups = new Map();
        for (const item of list) {
          const code = Number(
            item.cropGroupCode ??
              item.CropGroupCode ??
             
              item.intCropGroupCode ??
              0
          );
          const name = String(
            item.cropGroupName ??
              item.CropGroupName ??
              ""
          ).trim();

          if (code > 0 && name && !uniqueGroups.has(code)) {
            uniqueGroups.set(code, { code, name });
          }
        }
        const groups = Array.from(uniqueGroups.values());

        setCropGroups(groups);
        console.log("Fetched crop groups:", groups);
const defaultCropGroupCode =
  schemeCode === "5"
    ? 8
    : schemeCode === "48"
    ? 2
    : null;

const defaultGroup = groups.find(
  (g) => g.code === defaultCropGroupCode
);

if (defaultGroup) {
  setSelectedCropGroup(defaultGroup.code);
}
      } catch (err) {
        console.error("Error fetching crop groups:", err);
      } finally {
        setIsFetching(false);
      }
    };
    
    ["5", "48"].includes(schemeCode) && fetchCropGroups();
  }, [schemeCode, selectedSeason, selectedFinYear]);

  // Crop Name dropdown — re-fetches whenever Crop Group changes
  useEffect(() => {
    if (schemeCode !== "5" && schemeCode !== "48") return;

    // Only fetch when a Crop Group is actually selected
    if (!selectedCropGroup || Number(selectedCropGroup) === 0) {
      setCropNames([]);
      setSelectedCropName(0);
      return;
    }

    setCropNames([]);
    setSelectedCropName(0);

    const fetchCropNames = async () => {
      try {
        const baseUrl =
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;

        const payload = {
          cropGroupCode: Number(selectedCropGroup) || 0,
          cropCode: 0,
          schemeCode: 5,
        };

        const res = await axios.post(
          `${baseUrl}/api/Management/CommSeedRegistry/getCropNameList`,
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        const list = res?.data?.dataContent || [];
        const uniqueNames = new Map();
        for (const item of list) {
          const code = Number(item.cropCode ?? item.CropCode ?? item.cropNameCode ?? 0);
          const name = String(item.cropName ?? item.CropName ?? "").trim();
          if (code > 0 && name && !uniqueNames.has(code)) {
            uniqueNames.set(code, { code, name });
          }
        }
        setCropNames(Array.from(uniqueNames.values()));
      } catch (err) {
        console.error("Error fetching crop names:", err);
      }
    };

    fetchCropNames();
  }, [schemeCode, selectedCropGroup]);

    return (
      <>
        <section className="section">
          <div className="row surveydetailsBg">
            <div className="col-md-3">
              <label htmlFor="State" className="form-label">
                State
              </label>
              <Select
                options={optionState}
                // value={optionState.find(
                //   (option) =>
                //     stateValue &&
                //     stateValue[0] &&
                //     option.value === stateValue[0]
                // )}
                value={
                  stateValue && stateValue[0]
                    ? findMatchingOption(optionState, stateValue[0])
                    : null
                }
                onChange={handleChange}
                isClearable={!isStateDisabled}
                isSearchable={true}
                isDisabled={isStateDisabled}
                placeholder="Select State"
                classNamePrefix="select"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="District" className="form-label">
                District
              </label>
              <Select
                options={optionDistrict}
                // value={optionDistrict.find(
                //   (option) => option.value === districtValue
                // )}
                value={
                  districtValue
                    ? findDistrictSelectValue(optionDistrict, districtValue)
                    : null
                }
                onChange={handleChangeDistrict}
                isClearable={!isDistrictDisabled}
                isSearchable={true}
                isDisabled={isDistrictDisabled}
                isMulti={false}
                hideSelectedOptions={false}
                placeholder="Select District"
                classNamePrefix="select"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="SubDistrict" className="form-label">
                Sub District
              </label>
              <label style={{ color: "red" }}></label>
              <Select
                options={optionSubDistrict}
                // value={optionSubDistrict.find(
                //   (option) => option.value === subdistrictValue
                // )}
                value={
                  subdistrictValue
                    ? optionSubDistrict.find(
                        (o) => o.value === subdistrictValue
                      ) || null
                    : null
                }
                onChange={handleChangeSubDistrict}
                isClearable={true}
                isSearchable={true}
                isMulti={false}
                hideSelectedOptions={false}
                placeholder="Select Sub District"
                classNamePrefix="select"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="Village" className="form-label">
                Village
              </label>
              <label style={{ color: "red" }}></label>
              <Select
                options={optionVillage}
                // value={optionVillage.find(
                //   (option) => option.value === villageValue
                // )}
                value={
                  villageValue
                    ? optionVillage.find((o) => o.value === villageValue) ||
                      null
                    : null
                }
                onChange={handleChangeVillage}
                isClearable={true}
                isSearchable={true}
                isMulti={false}
                hideSelectedOptions={false}
                placeholder="Select Village"
                classNamePrefix="select"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="season" className="form-label">
                Season
              </label>
              <label style={{ color: "red" }}></label>
              <Select
                options={seasonOptions}
                // value={seasonOptions.find(
                //   (option) => option.value === seasonValue
                // )}
                value={selectedSeasonOption}
                onChange={(option) =>
                  setSeasonValue(option ? option.value : null)
                }
                isClearable
                isSearchable
                isMulti={false}
                hideSelectedOptions={false}
                placeholder="Select Season"
                classNamePrefix="select"
              />
            </div>
          
              {["5", "48"].includes(schemeCode) && (
  <div className="col-md-3">
    <label htmlFor="cropGroup" className="form-label">
      Crop Group
    </label>
    <Select
                  id="cropGroup"
                  options={cropGroups.map((group) => ({
                    value: group.code,
                    label: group.name,
                  }))}
                  value={
                    cropGroups
                      .map((g) => ({ value: g.code, label: g.name }))
                      .find((o) => o.value === Number(selectedCropGroup)) || null
                  }
                  onChange={(option) =>
                    setSelectedCropGroup(option ? option.value : 0)
                  }
                  isDisabled={schemeCode === "48"}
                  isClearable={false}
                  isSearchable
                  isMulti={false}
                  placeholder="Select Crop Group"
                  classNamePrefix="select"
                />

  </div>
)}

         {["5", "48"].includes(schemeCode) && (
  <div className="col-md-3">
    <label htmlFor="cropName" className="form-label">
      Crop Name
    </label>
    <Select
      id="cropName"
      options={cropNames.map((crop) => ({
        value: crop.code,
        label: crop.name,
      }))}
      value={
        cropNames
          .map((c) => ({ value: c.code, label: c.name }))
          .find((o) => o.value === Number(selectedCropName)) || null
      }
      onChange={(option) =>
        setSelectedCropName(option ? option.value : 0)
      }
      isClearable
      isSearchable
      isMulti={false}
      placeholder="Select Crop Name"
      classNamePrefix="select"
    />
  </div>
)}
            <div className="col-md-3">
              <label htmlFor="finYear" className="form-label">
                Financial Year
              </label>
              <Select
                id="finYear"
                options={finYears.map((year) => ({
                  value: year,
                  label: year,
                }))}
                value={
                  selectedFinYear
                    ? { value: selectedFinYear, label: selectedFinYear }
                    : null
                }
                onChange={(option) =>
                  setSelectedFinYear(option ? option.value : "All")
                }
                isClearable
                isSearchable={false}
                isMulti={false}
                hideSelectedOptions={false}
                placeholder="Select Financial Year"
                classNamePrefix="select"
              />
            </div>
            <br /> <br />
            <div className="col-md-12 d-flex justify-content-md-center mt-3">
              <button
                type="button"
                className="btn btn-primary farmrbtn me-md-2"
                onClick={ValidateAddUser}
              >
                Submit
              </button>
              <button
                type="button"
                className="btn btn-success me-md-2"
                onClick={ClearSearch}
              >
                Clear
              </button>
            </div>
          </div>

          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}

          {LoaderFarmer === false ? (
            ""
          ) : (
            <div className="overlay">
              <div className="overlay__inner">
                <div className="overlay__content">
                  <span className="spinner"></span>
                </div>
              </div>
            </div>
          )}

          {farmerData.length > 0 ? (
            <div className="row justify-content-lg-center">
              <div className="col-lg-12 ">
                <div className="card">
                  <MaterialReactTable
                    columns={columns}
                    data={farmerData}
                    enableColumnOrdering
                    enablePagination={true}
                    state={{ isLoading: isFetching ? true : false }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        {sessionStorage.getItem("schemeCodeModel") === "12" ? (
                          <Button
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={handleExportDataNew}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export in
                          </Button>
                        ) : (
                          <Button
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={handleExportData}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export in CSV
                          </Button>
                        )}
                      </Box>
                    )}
                  />
                </div>
              </div>
            </div>
          ) : (
            // Empty state - no message needed
            <></>
          )}
        </section>
      </>
    );
}

export default NMEOOP;